import { render, staticRenderFns } from "./b-nav.vue?vue&type=template&id=790dd2dc&"
import script from "./b-nav.vue?vue&type=script&lang=js&"
export * from "./b-nav.vue?vue&type=script&lang=js&"
import style0 from "./b-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports